/**
 * Central configuration for API endpoints.
 * It detects if the app is running on localhost and provides the correct backend URL.
 */

import axios from 'axios';
import { auth } from './firebase';

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

// Add global interceptor for Firebase token
axios.interceptors.request.use(async (config) => {
  if (auth.currentUser) {
    try {
      const token = await auth.currentUser.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    } catch (e) {
      console.error("Error getting ID token:", e);
    }
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// Base URL for the spaces API
export const API_BASE_URL = isLocalhost 
  ? 'http://localhost:8000/api/espacios'
  : (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/espacios');

// Root URL for other API categories
export const API_ROOT = API_BASE_URL.replace(/\/api\/espacios.*$/, '');

// Specific API endpoints
export const SHARE_API = `${API_ROOT}/api/share`;
export const PDF_GENERATOR_API_URL = `${API_ROOT}/api/generate-pdf`;
export const ASIGNACIONES_API = `${API_ROOT}/api/asignaciones`;
export const LEADS_ADMIN_API = `${API_ROOT}/api/admin/leads`;
export const PUBLIC_API = `${API_ROOT}/api/public/espacios`;
export const LEADS_API = `${API_ROOT}/api/leads`;
export const KPIS_API = `${API_ROOT}/api/kpis`;

export default {
  API_BASE_URL,
  API_ROOT,
  SHARE_API,
  PDF_GENERATOR_API_URL,
  ASIGNACIONES_API,
  LEADS_ADMIN_API,
  PUBLIC_API,
  LEADS_API,
  KPIS_API
};
